import React from 'react'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import type { Document } from '@contentful/rich-text-types'
import type {
  FooterText,
  MediaBlockText,
  MediaBlockTextFieldsFragment,
  TextBlockText,
  TextBlockTextFieldsFragment,
} from '@/graphql/types'
import type RichTextType from '@/models/contentful/richText-models'
import { getRenderOptionsDlp } from './getRenderOptionsDlp'
import styles from './richTextDlp.module.css'

type RichTextRendererInput =
  | TextBlockText
  | MediaBlockText
  | TextBlockTextFieldsFragment
  | MediaBlockTextFieldsFragment
  | FooterText
  | RichTextType

export const richTextRendererDlp = (richText: RichTextRendererInput | null | undefined) => {
  if (!richText) return null

  const richTextDocument = richText.json as Document
  const renderOptions = getRenderOptionsDlp(richText as unknown as RichTextType)
  return <div className={styles.richTextContent}>{documentToReactComponents(richTextDocument, renderOptions)}</div>
}
